import { API } from 'aws-amplify'

export default class PlaceCache {
  // Place name -> {"seats": [], "seat.rows": []} (as returned by place-seat-request)
  static placesSeats = new Map([]);

  static async retrievePlaceSeats(placeName) {
    if (PlaceCache.placesSeats.has(placeName)) {
      //console.log("Place Seats in cache");
      return Promise.resolve(PlaceCache.placesSeats.get(placeName));
    }
    let body = {
      body: {"place.ref": {"place.name": placeName}}
    };
    return API.post("place-seats-request", "/", body).then(response => {
      PlaceCache.placesSeats.set(placeName, response.Response);
      return response.Response;
    });
  }

  static cachedRequests = [];
  static addCachedRequest(placeName) {
    PlaceCache.cachedRequests = PlaceCache.cachedRequests.concat(placeName);
  }

  static executeOneCachedRequest() {
    if (PlaceCache.cachedRequests.length === 0) return;
    const name = PlaceCache.cachedRequests.pop();
    PlaceCache.retrievePlaceSeats(name).then(()=>{});
  }

}
setInterval((()=>{PlaceCache.executeOneCachedRequest()}), 5000);
